import { Link, useLocation } from 'react-router-dom';
import { getIndividualReportURL } from '../../../utils/getIndividualReportURL';
import { usePostHog } from '@posthog/react';

interface StudentNameLinkProps {
  studentId: string | null | undefined;
  classIds?: string[];
  className?: string;
  children: React.ReactNode;
}

export const StudentNameLink = ({ studentId, classIds, className, children }: StudentNameLinkProps) => {
  const posthog = usePostHog();
  const location = useLocation();
  if (!studentId) return <span>{children}</span>;
  return (
    <Link
      to={`/progress/${getIndividualReportURL({
        studentId,
        classIds,
      })}`}
      state={{ isrReturnTo: `${location.pathname}${location.search}${location.hash}` }}
      className={['tw-text-blue-700 tw-underline ph-no-autocapture', className].filter(Boolean).join(' ')}
      onClick={() => {
        posthog.capture('navigated_to_isr');
      }}
    >
      {children}
    </Link>
  );
};

export default StudentNameLink;
